<template>
  <main>
    <organism-policy-management
      :fields="fields"
      :items="items"
      @deletePolicy="deletePolicy"
    ></organism-policy-management>
  </main>
</template>

<script>
import OrganismPolicyManagement from "@/components/organisms/OrganismPolicyManagement.vue"
import {
  getPolicyManagement,
  deletePolicyManagementById,
} from "@/api/api-module"
import mixins from "@/mixins"
import { DateTime } from "luxon"
export default {
  name: "PolicyManagement",
  mixins: [mixins],
  components: {
    OrganismPolicyManagement,
  },
  data() {
    return {
      fields: [
        { field: "name", label: "NAME", sortable: true },
        { field: "updateDate", label: "UPDATE DATE", sortable: true },
        { field: "description", label: "DESCRIPTION", sortable: true },
        {
          field: "delete",
          label: "DELETE",
          sortable: false,
          thClass: "text-center",
        },
      ],
      items: [],
    }
  },
  mounted() {
    this.getPolicyManagementList()
  },
  methods: {
    async getPolicyManagementList() {
      this.showLoading(true)
      this.items = []
      await getPolicyManagement()
        .then((response) => {
          response.forEach((policy) => {
            this.items.push({
              id: policy.policyId,
              name: policy.policyName,
              updateDate: DateTime.fromISO(policy.updateDate).toFormat(
                "dd LLL yyyy T"
              ),
              description: policy.policyDescription,
              isPolicyDefault: policy.policyDefault,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    // delete policy
    async deletePolicy(id, isDisableMonitoring) {
      this.showLoading(true)
      const response = await deletePolicyManagementById(id, isDisableMonitoring)
      this.getPolicyManagementList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Policy deleted successfully")
      } else {
        this.toastError("Policy deleted failed")
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
